// extracted by mini-css-extract-plugin
export var subtitle = "_96-2";
export var title = "_96-0";
export var titleNoWrap = "_96-1";